import React from 'react';

import { useAppContext } from 'hooks/useContext';
import HeaderFreecode from 'components/HeaderFreecode/HeaderFreecode';
import { FreecodePageBackground, FreecodePageContentContainer } from './styles';

export default function FreecodePage({ children, contest, headerLinks = [] }) {
  const { isDarkMode } = useAppContext();

  return (
    <FreecodePageBackground isDarkMode={isDarkMode}>
      <HeaderFreecode contest={contest} headerLinks={headerLinks} />
      <FreecodePageContentContainer>{children}</FreecodePageContentContainer>
    </FreecodePageBackground>
  );
}
